import { ReactNode } from "react";
import { containerVariants, styles } from "./Container.style";
import { cx } from "../../../styled-system/css";

export namespace Variant {
  export enum Top {
    Standard = "standard",
    Medium = "medium",
    Large = "large",
    None = "none",
  }
  export enum Bottom {
    Standard = "standard",
    Medium = "medium",
    Large = "large",
    Single = "single",
    None = "none",
  }
}

export interface ContainerProps {
  paddingTop?: Variant.Top;
  paddingBottom?: Variant.Bottom;
  noPaddingMobile?: boolean;
  noPaddingDesktop?: boolean;
  maxWidth?: string;
  className?: string;
  children?: ReactNode;
}

export const Container = (props: ContainerProps) => {
  const { children, paddingTop, paddingBottom, noPaddingMobile = false, noPaddingDesktop = false, className } = props;

  return (
    <div
      className={cx(
        styles.container(noPaddingMobile, noPaddingDesktop),
        containerVariants({ top: paddingTop, bottom: paddingBottom }),
        className,
      )}
      data-testid="container"
    >
      {children}
    </div>
  );
};
